<template>
  <div style="padding: 20px; height: 100%">
    <div
      style="
        padding: 20px;
        border-radius: 10px;
        box-shadow: 0 0 5px 1px #e2e2e2;
        height: 100%;
      "
    >
      <ul
        style="
          border-bottom: 1px solid #e2e2e2;
          padding-bottom: 10px;
          font-size: 13px;
          font-weight: 600;
        "
      >
        个人信息
      </ul>
      <el-form
        :model="state.model"
        label-width="100px"
        style="width: 40%; margin-top: 20px"
        :scroll-to-error="true"
        ref="formDom"
      >
        <el-form-item
          label="姓名"
          prop="name"
          :rules="[{ required: true, message: '请填写姓名', trigger: 'blur' }]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号码"
          prop="phone"
          :rules="[
            { required: true, message: '请填写手机号码', trigger: 'blur' },
            {
              validator: (rule, value, callback) => {
                let reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
                if (!value) {
                  return callback(new Error('手机号码不能为空'));
                } else if (!reg.test(value)) {
                  return callback(new Error('手机号格式不正确'));
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.phone"></el-input>
        </el-form-item>
        <el-form-item
          label="邮箱"
          prop="email"
          :rules="[
            {
              validator: (rule, value, callback) => {
                let reg = /^(?:\w+\.?)*\w+@(?:\w+\.)*\w+$/;
                if (value) {
                  if (!reg.test(value))
                    return callback(new Error('邮箱格式不正确'));
                  else callback();
                } else {
                  callback();
                }
              },
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="state.model.email"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 80px" type="primary" @click="onSubmit()">
            提交
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { home_getuser, home_setuser } from "@/http/home";
import { ElMessage } from "element-plus";

export default {
  setup() {
    const formDom = ref(null);
    const state = reactive({
      model: {},
    });

    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      home_getuser().then((res) => {
        if (res.status == 200) state.model = res.data.data;
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (!valid) return false;

        const data = {
          name: state.model.name,
          phone: state.model.phone,
          email: state.model.email,
        };

        home_setuser(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success("操作成功。");
            onLoad();
          }
        });
      });
    };
    return { state, onSubmit, formDom };
  },
};
</script>
<style scoped></style>
